import { gql } from "@apollo/client";

export const createOrganizationAndLensSpace = gql`
    mutation createOrganizationAndLensSpace($organizationName: String!, $lensSpaceName: String!) {
        createMyLensesOrganizationAndLensSpace(
            input: { organizationName: $organizationName, lensSpaceName: $lensSpaceName }
        ) {
            organization {
                id
                name

                lensSpacesList {
                    id
                    name
                }
            }
        }
    }
`;
